import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import MsxIcons from '../features/msx-icons';
import I10n from '../features/i10n';
import Checkbox from '../atoms/checkbox';
import Dropdown from './dropdown';
import { Scrollbars } from 'react-custom-scrollbars';
import { PRIMARY_COLOR, SECONDARY_COLOR } from '../color-constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  color: #626469;
  @media (max-width: 800px) {
    display: none;
  }
`;

const MobileTitleWrapper = styled.div`
  display: none;
  flex-direction: column;
  justify-content: center;
  color: #626469;
  cursor: pointer;
  @media (max-width: 800px) {
    display: flex;
  }
`;

const MobileLine = styled.div`
  flex: 1 1 0px;
  height: 1px;
  background-color: #EDEDED;
  margin: 0px 5px;
`;

const MobileIconWrapper = styled.div`
  transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  width: 32px;
  height: 32px;
  box-sizing: content-box;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TitleAndIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.span`
  font-weight: 400;
  font-size: 16px;
  margin-left: 5px;
`;

const CategoriesWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-right: -15px;
  @media (max-width: 800px) {
    margin-top: 20px;
    margin-right: -6px;
    ${props => !props.isMobileOpen && `display: none;`}
    flex-direction: column;
  }
`;

const CategoryTitleAndFilter = styled.div`
  display: flex;
  flex-direction: column;
`;

const CategoryTitle = styled.span`
  font-weight: 700;
  font-size: 16px;
  color: #333333;
`;

const CategoryFilter = styled.span`
  font-weight: 400;
  font-size: 14px;
  color: #626469;
`;

const CategoryColor = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  width: 4px;
  ${props => props.isBlocked ? `background-color: #A0A4A8;` : `
    background-color: ${SECONDARY_COLOR};
    background-color: var(--se-primary, ${SECONDARY_COLOR});
  `}
`;

const CheckboxAndTextWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  cursor: pointer;
`;

const ChoiceText = styled.span`
  margin-left: 10px;
  font-weight: 400;
  font-size: 16px;
  color: #0F0F0F;
`;

const ClearLink = styled.span`
  font-weight: 400;
  font-size: 16px;
  cursor: pointer;
  color: ${PRIMARY_COLOR};
  :hover {
    text-decoration: underline;
  }
`;

const ClearAllLink = styled(ClearLink)`
  margin-left: 5px;
`;

const ClearLinkWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 10px;
`;

const ClearAllLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${PRIMARY_COLOR};
  cursor: pointer;


  :hover {
    ${ClearLink} {
        text-decoration: underline;
    }
  }
`;

const SearchWrapper = styled.div`
  position: relative;
  display: flex;
  margin-bottom: 10px;
`;

const SearchReferenceInput = styled.input`
  height: 30px;
  width: 100%;
  padding: 5px 24px 5px 5px;

  border: 1px solid #E6E6E6;
  color: #A4A4A4;
  font-weight: bold;
`;

const SearchIconWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  top: 0px;
  right: 2px;
  bottom: 0px;
`;

const ScrollbarWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
`;

const DropdownWrapper = styled.div`
  display: flex;
  width: calc(33% - 10px);
  margin-bottom: 10px;
  margin-right: 10px;
  @media (max-width: 800px) {
    flex: unset;
    width: 100%;
  }
`;

const ResetFilterWrapper = styled.div`
  padding: 10px 20px;
  display: flex;
  justify-content: center;
  background-color: #EDEDED;
  margin: 0px -10px -10px -10px;
`;

const ResetFilterLabel = styled.span`
  font-weight: 400;
  font-size: 14px;
  color: #626469;
  text-align: center;
`;

class CallByRange extends React.Component {

  static propTypes = {
    displayableValues: PropTypes.object,
    selectedValues: PropTypes.object,
    onToggleValue: PropTypes.func,
    clearCategory: PropTypes.func,
    onReset: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {
      rangesSearch: '',
      referencesSearch: '',
      technologiesOpened: false,
      rangesOpened: false,
      referencesOpened: false,
      isMobileOpen: true
    };
  }

  filterRangesSearch = () => {
    let result = this.props.displayableValues?.ranges || [];
    if (this.state.rangesSearch && this.state.rangesSearch.length > 0) {
      result = result.filter(range => range.toLowerCase().includes(this.state.rangesSearch.toLowerCase()) || I10n.get(`category.${range}.name`, 'data').toLowerCase().includes(this.state.rangesSearch.toLowerCase()));
    }
    return result;
  }

  filterReferencesSearch = () => {
    let result = this.props.displayableValues?.references || [];
    if (this.state.referencesSearch && this.state.referencesSearch.length > 0) {
      result = result.filter(ref => ref.toLowerCase().includes(this.state.referencesSearch.toLowerCase()));
    }
    return result;
  }

  render = () => {
    const selectedTechnologies = this.props.selectedValues?.ranges ? Object.keys(this.props.selectedValues?.technologies) : [];
    const selectedRanges = this.props.selectedValues?.ranges ? Object.keys(this.props.selectedValues?.ranges) : [];
    const selectedReferences = this.props.selectedValues?.references ? Object.keys(this.props.selectedValues?.references) : [];

    const displayableTechnologies = this.props.displayableValues?.technologies || [];
    const displayableRanges = this.filterRangesSearch();
    const displayableReferences = this.filterReferencesSearch();

    let technologiesFilter = I10n.get('screen.start_configuration_screen.cbr.no_filter');
    let technologiesBlocked = false;

    if (selectedRanges.length > 0 || selectedReferences.length > 0) {
      technologiesBlocked = true;
      technologiesFilter = I10n.get(`screen.start_configuration_screen.create.${displayableTechnologies[0]}`);
      if (displayableTechnologies.length > 1) {
        technologiesFilter = I10n.get(`screen.start_configuration_screen.cbr.multiple_filter`);
      }
    } else if (selectedTechnologies.length > 0) {
      technologiesFilter = I10n.get(`screen.start_configuration_screen.create.${selectedTechnologies[0]}`);
      if (selectedTechnologies.length > 1) {
        technologiesFilter = I10n.get(`screen.start_configuration_screen.cbr.multiple_filter`);
      }
    }

    let rangesFilter = I10n.get('screen.start_configuration_screen.cbr.no_filter');
    let rangesBlocked = false;

    if (selectedReferences.length > 0) {
      rangesBlocked = true;
      rangesFilter = I10n.get(`category.${this.props.displayableValues?.ranges[0]}.name`, 'data');
      if (this.props.displayableValues?.ranges.length > 1) {
        rangesFilter = I10n.get(`screen.start_configuration_screen.cbr.multiple_filter`);
      }
    } else if (selectedRanges.length > 0) {
      rangesFilter = I10n.get(`category.${selectedRanges[0]}.name`, 'data');
      if (selectedRanges.length > 1) {
        rangesFilter = I10n.get(`screen.start_configuration_screen.cbr.multiple_filter`);
      }
    }

    let referencesFilter = I10n.get('screen.start_configuration_screen.cbr.no_filter');
    if (selectedReferences.length > 0) {
      referencesFilter = selectedReferences[0];
      if (selectedReferences.length > 1) {
        referencesFilter = I10n.get(`screen.start_configuration_screen.cbr.multiple_filter`);
      }
    }

    return (<Container>
      <TitleWrapper>
        <TitleAndIconWrapper >
          <MsxIcons name="filter2"></MsxIcons>
          <Title>{I10n.get('screen.start_configuration_screen.cbr.title')}</Title>
        </TitleAndIconWrapper>
        {(selectedTechnologies.length + selectedRanges.length + selectedReferences.length) > 0 && <ClearAllLinkWrapper>
          <MsxIcons name="replace"></MsxIcons>
          <ClearAllLink onClick={(event) => { event.stopPropagation(); this.props.onReset(); }}>{I10n.get('screen.start_configuration_screen.cbr.clear_all')}</ClearAllLink> </ClearAllLinkWrapper>}
      </TitleWrapper>
      <MobileTitleWrapper onClick={() => { this.setState({ isMobileOpen: !this.state.isMobileOpen }); }}>
        <TitleAndIconWrapper>
          <MsxIcons name="filter2"></MsxIcons>
          <Title>{I10n.get('screen.start_configuration_screen.cbr.title')}</Title>
          <MobileLine></MobileLine>
          <MobileIconWrapper isOpen={this.state.isMobileOpen}>
            <MsxIcons name="down-arrow" size="small"></MsxIcons>
          </MobileIconWrapper>
        </TitleAndIconWrapper>
        {this.state.isMobileOpen && (selectedTechnologies.length + selectedRanges.length + selectedReferences.length) > 0 && <ClearLink onClick={(event) => { event.stopPropagation(); this.props.onReset(); }}>{I10n.get('screen.start_configuration_screen.cbr.clear_all')}</ClearLink>}
      </MobileTitleWrapper>
      <CategoriesWrapper isMobileOpen={this.state.isMobileOpen}>
        <DropdownWrapper>
          <Dropdown id="call-by-range-technology-dropdown-header" isOpen={this.state.technologiesOpened} needScroll={false} onHeaderClick={() => {
            this.setState({
              technologiesOpened: !this.state.technologiesOpened,
              rangesOpened: false,
              referencesOpened: false,
              rangesSearch: '',
              referencesSearch: ''
            });
          }}
            renderHeaderContent={() => {
              return (<>
                <CategoryColor isBlocked={technologiesBlocked}></CategoryColor>
                <CategoryTitleAndFilter>
                  <CategoryTitle>{I10n.get('screen.start_configuration_screen.cbr.technologies')}</CategoryTitle>
                  <CategoryFilter>{technologiesFilter}</CategoryFilter>
                </CategoryTitleAndFilter>
              </>
              );
            }}
            renderContent={() => {
              return (<>
                {
                  selectedTechnologies.length > 0 && selectedRanges.length === 0 && selectedReferences.length === 0 && <ClearLinkWrapper onClick={() => { this.props.clearCategory('technologies'); }}>
                    <ClearLink>{I10n.get('screen.start_configuration_screen.cbr.clear')}</ClearLink>
                  </ClearLinkWrapper>
                }
                {displayableTechnologies.map((tech, idx) => {
                  const isSelectable = (selectedReferences.length === 0 && selectedRanges.length === 0);
                  return (<CheckboxAndTextWrapper key={idx} onClick={(event) => {
                    event.stopPropagation();
                    if (isSelectable) {
                      this.props.onToggleValue(tech, 'technologies');
                    }
                  }}>
                    <Checkbox checked={this.props.selectedValues?.technologies[tech] === true || !isSelectable} disabled={!isSelectable}></Checkbox>
                    <ChoiceText>{I10n.get(`screen.start_configuration_screen.create.${tech}`)}</ChoiceText>
                  </CheckboxAndTextWrapper>);

                })}
                {(selectedRanges.length > 0 || selectedReferences.length > 0) && <ResetFilterWrapper>
                  <ResetFilterLabel>{I10n.get('screen.start_configuration_screen.cbr.reset_filter_label')}</ResetFilterLabel>
                </ResetFilterWrapper>}
              </>);
            }}
            onClose={() => {
              this.setState({
                technologiesOpened: false
              });
            }}
          >
          </Dropdown>
        </DropdownWrapper>
        <DropdownWrapper>
          <Dropdown id="call-by-range-range-dropdown-header" isOpen={this.state.rangesOpened} needScroll={false} onHeaderClick={() => {
            this.setState({
              technologiesOpened: false,
              rangesOpened: !this.state.rangesOpened,
              referencesOpened: false,
              rangesSearch: '',
              referencesSearch: '',
            });
          }}
            renderHeaderContent={() => {
              return (
                <>
                  <CategoryColor isBlocked={rangesBlocked}></CategoryColor>
                  <CategoryTitleAndFilter>
                    <CategoryTitle>{I10n.get('screen.start_configuration_screen.cbr.ranges')}</CategoryTitle>
                    <CategoryFilter>{rangesFilter}</CategoryFilter>
                  </CategoryTitleAndFilter>
                </>
              );
            }}
            renderContent={() => {
              return (<>
                {
                  selectedRanges.length > 0 && selectedReferences.length === 0 && <ClearLinkWrapper onClick={() => { this.props.clearCategory('ranges'); }}>
                    <ClearLink>{I10n.get('screen.start_configuration_screen.cbr.clear')}</ClearLink>
                  </ClearLinkWrapper>
                }
                <SearchWrapper>
                  <SearchReferenceInput
                    type="search"
                    placeholder={I10n.get('screen.start_configuration_screen.cbr.search')}
                    value={this.state.rangesSearch}
                    onChange={(event) => { this.setState({ rangesSearch: event.currentTarget.value }); }}
                  >
                  </SearchReferenceInput>
                  <SearchIconWrapper>
                    <MsxIcons name="search"></MsxIcons>
                  </SearchIconWrapper>
                </SearchWrapper>
                {displayableRanges.length === 0 && I10n.get('screen.start_configuration_screen.cbr.no_results')}
                {displayableRanges.map((range, idx) => {
                  const isSelectable = selectedReferences.length === 0;
                  return (<CheckboxAndTextWrapper id={`${range}-cbr-range`} key={idx} onClick={(event) => {
                    event.stopPropagation();
                    if (isSelectable) {
                      this.props.onToggleValue(range, 'ranges');
                    }
                  }}>
                    <Checkbox checked={this.props.selectedValues?.ranges[range] === true || !isSelectable} disabled={!isSelectable}></Checkbox>
                    <ChoiceText>{I10n.get(`category.${range}.name`, 'data')}</ChoiceText>
                  </CheckboxAndTextWrapper>);
                })}
                {selectedReferences.length > 0 && <ResetFilterWrapper>
                  <ResetFilterLabel>{I10n.get('screen.start_configuration_screen.cbr.reset_filter_label')}</ResetFilterLabel>
                </ResetFilterWrapper>}
              </>);
            }}
            onClose={() => {
              this.setState({
                rangesOpened: false,
              });
            }}
          >
          </Dropdown>
        </DropdownWrapper>
        <DropdownWrapper>

          <Dropdown id="call-by-range-reference-dropdown-header" isOpen={this.state.referencesOpened} needScroll={true} onHeaderClick={() => {
            this.setState({
              technologiesOpened: false,
              rangesOpened: false,
              referencesOpened: !this.state.referencesOpened,
              rangesSearch: '',
              referencesSearch: ''
            });
          }}
            renderHeaderContent={() => {
              return (
                <>
                  <CategoryColor isBlocked={false}></CategoryColor>
                  <CategoryTitleAndFilter>
                    <CategoryTitle>
                      {I10n.get('screen.start_configuration_screen.cbr.references')}
                    </CategoryTitle>
                    <CategoryFilter>{referencesFilter}</CategoryFilter>
                  </CategoryTitleAndFilter>
                </>
              );
            }}
            renderContent={() => {
              return (<>
                {
                  selectedReferences.length > 0 && <ClearLinkWrapper onClick={() => { this.props.clearCategory('references'); }}>
                    <ClearLink>{I10n.get('screen.start_configuration_screen.cbr.clear')}</ClearLink>
                  </ClearLinkWrapper>
                }
                <SearchWrapper>
                  <SearchReferenceInput
                    type="search"
                    placeholder={I10n.get('screen.start_configuration_screen.cbr.search')}
                    value={this.state.referencesSearch}
                    onChange={(event) => { this.setState({ referencesSearch: event.currentTarget.value }); }}
                  ></SearchReferenceInput>
                  <SearchIconWrapper>
                    <MsxIcons name="search"></MsxIcons>
                  </SearchIconWrapper>
                </SearchWrapper>
                <ScrollbarWrapper>
                  <Scrollbars>
                    {displayableReferences.length === 0 && I10n.get('screen.start_configuration_screen.cbr.no_results')}
                    {displayableReferences.map((ref, idx) => {
                      return (<CheckboxAndTextWrapper key={idx} onClick={(event) => {
                        event.stopPropagation();
                        this.props.onToggleValue(ref, 'references');
                      }}>
                        <Checkbox checked={this.props.selectedValues?.references[ref] === true}></Checkbox>
                        <ChoiceText>{ref}</ChoiceText>
                      </CheckboxAndTextWrapper>);
                    })}
                  </Scrollbars>
                </ScrollbarWrapper>
              </>);
            }}
            onClose={() => {
              this.setState({
                referencesOpened: false
              });
            }}
          >
          </Dropdown>
        </DropdownWrapper>
      </CategoriesWrapper>
    </Container>);
  }
}

export default CallByRange;
